const NepalSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111990)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path d="M39.8824 22.1735L39.8819 22.1729L39.8818 22.1735H39.8824Z" fill="#0052B4" />
      <path
        d="M39.882 22.1744C39.882 22.1743 39.8821 22.1741 39.8821 22.1738L17.9489 0.104492C16.9595 0.205352 15.9912 0.37832 15.0498 0.618086C6.39828 2.82082 0 20.0005 0 20.0005C0 20.0005 27.9998 38.7376 31.1941 36.5758C31.8333 36.1433 32.4461 35.6748 33.0295 35.1732L20.0309 22.1744H39.882Z"
        fill="#0052B4"
      />
      <path
        d="M34.7826 19.9997L15.3316 0.548828C6.53813 2.65172 0 10.5616 0 19.9997C0 31.0453 8.95438 39.9997 20 39.9997C24.1898 39.9997 28.0779 38.7105 31.2913 36.5084L14.7826 19.9997H34.7826Z"
        fill="#D80027"
      />
      <path
        d="M19.0215 29.5303L16.5789 28.3814L17.8796 26.0159L15.2272 26.5233L14.8912 23.8438L13.0437 25.8145L11.1963 23.8438L10.8601 26.5233L8.20787 26.0158L9.50857 28.3814L7.06592 29.5303L9.50857 30.6791L8.20787 33.0448L10.8603 32.5374L11.1962 35.2168L13.0437 33.2461L14.8912 35.2168L15.2272 32.5374L17.8795 33.0448L16.5788 30.6793L19.0215 29.5303Z"
        fill="#F0F0F0"
      />
      <path
        d="M17.3915 11.093L15.6149 10.2574L16.561 8.53688L14.6318 8.90594L14.3874 6.95703L13.0437 8.39039L11.7 6.95703L11.4555 8.90594L9.52635 8.53688L10.4724 10.2574L8.6958 11.093L13.0437 11.9627L17.3915 11.093Z"
        fill="#F0F0F0"
      />
      <path
        d="M18.2605 11.0918C18.2605 13.9733 15.9246 16.3092 13.0431 16.3092C10.1616 16.3092 7.82568 13.9733 7.82568 11.0918"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111990">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default NepalSvg;
